import type {
  GwpVariantPickerVariant,
  GwpVariantPickerWidgetConfig,
  ResolvedGwpVariantPickerDeviceConfig,
} from "@intelligems/ig-types/schemas/widgets/gwp-variant-picker";
import type { WidgetDeviceType } from "@intelligems/ig-types/schemas/widgets/common";
import { merge } from "@intelligems/ig-utils/widgets/merge";

export const DEFAULT_GWP_HEADING = "Select your free gift";

export function getDefaultDeviceConfig(
  device: WidgetDeviceType,
  variant: GwpVariantPickerVariant = "gwpVariantPicker"
) {
  const config: ResolvedGwpVariantPickerDeviceConfig = {
    device,
    variant,
    styles: {
      backgroundColors: {
        container: "#FFFFFF",
        button: "#303030",
        border: "#D4D4D4",
      },
      textColors: {
        headingAndProduct: "#1A1A1A",
        button: "#FFFFFF",
        customPrice: "#29845A",
      },
      typography: {
        heading: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        productName: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        strikethroughPrice: {
          fontSize: "14px",
          fontStyle: "regular",
        },
        button: {
          fontSize: "14px",
          fontStyle: "medium",
        },
        customPrice: {
          fontSize: "14px",
          fontStyle: "medium",
        },
      },
      appearance: {
        cornerRadius: 6,
        borderThickness: 1,
        textAlignment: "left",
        imageWidth: 60,
        imageCropping: "1:1",
      },
    },
    variables: {
      variantSettings: {
        enabled: true,
        products: [],
      },
      textReplacements: {
        heading: DEFAULT_GWP_HEADING,
        button: "Add to cart",
        customPrice: "FREE",
      },
      strikethroughPriceType: "regularPrice",
      settings: {
        renderLocations: ["cart"],
      },
    },
  };
  return config;
}

export function resolveDesktopGwpVariantPickerConfig(
  config: GwpVariantPickerWidgetConfig
) {
  return merge(
    getDefaultDeviceConfig("desktop", config.desktop?.variant),
    config.desktop
  );
}

export function resolveMobileGwpVariantPickerConfig(
  config: GwpVariantPickerWidgetConfig
) {
  return merge(
    getDefaultDeviceConfig(
      "mobile",
      config.mobile?.variant ?? config.desktop?.variant
    ),
    (merger) => {
      merger.merge(config.desktop);
      merger.merge(config.mobile);
    }
  );
}

export const resolveGwpVariantPickerConfig = (
  config: GwpVariantPickerWidgetConfig
) => {
  return {
    desktop: resolveDesktopGwpVariantPickerConfig(config),
    mobile: resolveMobileGwpVariantPickerConfig(config),
  };
};
